import { render, staticRenderFns } from "./sidepanel-unit-4.vue?vue&type=template&id=2b2eb26d&scoped=true"
import script from "./sidepanel-unit-4.vue?vue&type=script&lang=js"
export * from "./sidepanel-unit-4.vue?vue&type=script&lang=js"
import style0 from "./sidepanel-unit-4.vue?vue&type=style&index=0&id=2b2eb26d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2eb26d",
  null
  
)

export default component.exports